import { getDday } from '@repo/utils';
import { Button, Icon } from '@successmode-ktp/kui';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CalendarModal } from '..';

type Props = {
  nationality: string;
  departureDate: string;
  firstRefundDate?: string;
  onClick: (v: string) => void;
};

export const DepartureDate = ({
  nationality,
  departureDate,
  firstRefundDate,
  onClick,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [departure, setDeparture] = useState(departureDate);

  useEffect(() => {
    setDeparture(departureDate);
  }, [isOpen]);

  return (
    <>
      <Container>
        <Text>{nationality === 'KOR' ? '출국 예정일' : 'My\nDeparture'}</Text>
        <div>
          <Button
            type='button'
            theme='mono'
            size='sm'
            onClick={() => setIsOpen(true)}
            style={{ padding: '0 12px 0 16px', gap: '2px' }}
          >
            {getDday(departureDate)}
            <Icon.ChevronDown />
          </Button>
        </div>
      </Container>
      {isOpen && (
        <CalendarModal
          onChange={setDeparture}
          nationality={nationality}
          departureDate={departure}
          firstRefundDate={firstRefundDate}
          onClose={() => setIsOpen(false)}
          onClick={() => {
            onClick(departure);
            setIsOpen(false);
          }}
        />
      )}
    </>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const Text = styled.p`
  color: var(--KTP-Grayscale-35, var(--KTP-Color-Mono-35, #a7a7a7));
  font-size: 14px;
  font-weight: 500;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
  white-space: pre-wrap;
`;
